import { render, staticRenderFns } from "./singleChoiceModel.vue?vue&type=template&id=7e22fd04&scoped=true"
import script from "./singleChoiceModel.vue?vue&type=script&lang=js"
export * from "./singleChoiceModel.vue?vue&type=script&lang=js"
import style0 from "./singleChoiceModel.vue?vue&type=style&index=0&id=7e22fd04&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e22fd04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e22fd04')) {
      api.createRecord('7e22fd04', component.options)
    } else {
      api.reload('7e22fd04', component.options)
    }
    module.hot.accept("./singleChoiceModel.vue?vue&type=template&id=7e22fd04&scoped=true", function () {
      api.rerender('7e22fd04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/auditManage/components/singleChoiceModel.vue"
export default component.exports